export const EXCMCUSTOMFIELDVALUE_DELETE_RESET = 'EXCMCUSTOMFIELDVALUE_DELETE_RESET'
export const EXCMCUSTOMFIELDVALUE_DELETE_SET_ERROR = 'EXCMCUSTOMFIELDVALUE_DELETE_SET_ERROR'
export const EXCMCUSTOMFIELDVALUE_DELETE_SET_DELETED = 'EXCMCUSTOMFIELDVALUE_DELETE_SET_DELETED'
export const EXCMCUSTOMFIELDVALUE_DELETE_TOGGLE_LOADING = 'EXCMCUSTOMFIELDVALUE_DELETE_TOGGLE_LOADING'
